import * as React from 'react'
import { useSearchParams } from 'react-router-dom'

import Passage from './Passage'
import { DisplayPassage } from '../data/mappers'

export default function Passages({
  realtimePassages,
  theoreticPassages,
  displayLimit,
}: {
  realtimePassages: DisplayPassage[]
  theoreticPassages: DisplayPassage[]
  displayLimit: number
}) {
  const [searchParams] = useSearchParams()
  const debug = searchParams.get('debug')

  const passages = realtimePassages.length
    ? realtimePassages
    : theoreticPassages

  return (
    <ul
      className="grid h-full m-0 p-0"
      title={
        debug ? `${realtimePassages.length ? 'Realtime' : 'Theoretisch'}` : ''
      }
      // Create a grid with a number of rows equal to the display limit
      // If there are fewer passages than the display limit, it will create "ghost" rows
      style={{ gridTemplateRows: `repeat(${displayLimit}, 1fr)` }}
    >
      {passages
        .slice(0, displayLimit)
        .sort((a, b) => {
          // Reeds vertrokken doorkomsten moeten bovenaan getoond worden
          if (a.isDeparted === b.isDeparted) {
            return 0
          }
          return a.isDeparted ? -1 : 1
        })
        .map((passage) => (
          <Passage passage={passage} key={passage.id} />
        ))}
    </ul>
  )
}
